import { preprocess } from '@artica/assets';
import { RepeatWrapping } from 'three';

preprocess('path_extrude_2', function preprocessHeroPaths(pathextrude2) {
  const geom = pathextrude2.nodes.Sweep2.geometry.clone();
  geom.scale(0.0025, 0.0025, 0.02);
  geom.rotateY(-Math.PI / 2);

  pathextrude2.nodes.Sweep2.geometry = geom;

  return pathextrude2;
});

preprocess('extrude_tex', function preprocessHeroPaths(extrudetex) {
  extrudetex.wrapS = extrudetex.wrapT = RepeatWrapping;
  return extrudetex;
});
